import { config } from '../utils/constants/api.constants';
import { convertObjectToParams } from '../utils/utils';

let {
  baseUrl,
  v1,
  user,
  count,
  activeStatus,
  organization,
  group,
  uploadImage,
  deleteImage,
} = config.api.userManagementV2;

export default (api) => {
  const getUsers = (params) => {
    const url = `${baseUrl}${v1}${user}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getUsersCount = (params) => {
    const url = `${baseUrl}${v1}${user}${count}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const createUser = (username, rawData = {}) => {
    const url = `${baseUrl}${v1}${user}/${username}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, rawData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateUser = (username, rawData = {}) => {
    const url = `${baseUrl}${v1}${user}/${username}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const deleteUser = (username, params = {}, rawData = {}) => {
    const url = `${baseUrl}${v1}${user}/${username}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .delete(url, rawData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const toggleUserActiveStatus = (username, params = {}, rawData = {}) => {
    const url = `${baseUrl}${v1}${user}${activeStatus}/${username}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getOrganizations = (params) => {
    const url = `${baseUrl}${v1}${user}${organization}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const searchGroup = (params) => {
    const url = `${baseUrl}${v1}${user}${group}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const uploadUserImage = (params, rawData) => {
    const url = `${baseUrl}${v1}${user}${uploadImage}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, rawData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const deleteUserImage = (params) => {
    const url = `${baseUrl}${v1}${user}${deleteImage}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .delete(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getUsers,
    getUsersCount,
    createUser,
    updateUser,
    deleteUser,
    toggleUserActiveStatus,
    getOrganizations,
    searchGroup,
    uploadUserImage,
    deleteUserImage,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
